module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("面板")]), _vm._v(" "), _c('h2', [_vm._v("Basic")]), _vm._v(" "), _c('h3', [_vm._v("example")]), _vm._v(" "), _c('uk-panel', {
    attrs: {
      "title": "panel header"
    }
  }, [_vm._v("\n    Panel body\n  ")]), _vm._v(" "), _c('h3', [_vm._v("code")]), _vm._v(" "), _c('code-block', [_vm._v(_vm._s(_vm.usages.basic))]), _vm._v(" "), _c('h2', [_vm._v("Customize slots")]), _vm._v(" "), _c('h3', [_vm._v("example")]), _vm._v(" "), _c('uk-panel', [_c('header', {
    slot: "header"
  }, [_c('h3', [_vm._v("Custom header")])]), _vm._v("\n    Panel body\n  ")]), _vm._v(" "), _c('h3', [_vm._v("code")]), _vm._v(" "), _c('code-block', [_vm._v(_vm._s(_vm.usages.customize))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c843106a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/docs/UkPanel.doc.vue
// module id = 302
// module chunks = 2